<script setup lang="ts">
import { PrimaryButton } from '@es-bill/es-bill-common-components';
import { useI18n } from 'vue-i18n';

const { t } = useI18n();
</script>

<template>
  <v-container class="containerStandard">

    <p class="textHeadline">{{ t('registrationInfo') }}</p>

    <p class="textDescriptor">
      {{ t('registrationMessage') }}
    </p>
    <br/>
    <PrimaryButton :label="t('toWebsite')" href="https://www.so-strom.at/" target="_blank" :text="t('toWebsite')"/>

  </v-container>
</template>

<style scoped lang="scss">

</style>
